import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Plan", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Report", -1)

import TimingComponent from '@/components/Workspaces/todos/_spec/TicketTiming.vue'
import AppointmentComponent from '@/components/Workspaces/_spec/AppointmentCreator.vue'
import { reactive } from 'vue';
import { useAppContext } from '@/app/_tech';
import { ProjectModel } from '@/app.context/workspace/project.rmodel';
import {CategoryOperation} from './CagegoryMenuComponent.types'
import { Category } from '@/logic/workspaces/persons/_def'

//import {Category} from src\logic\workspaces\persons\_def.ts


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryMenuComponent',
  props: /*#__PURE__*/_mergeModels({
    category: {},
    project_model: {},
    prompt: { type: Function }
  }, {
    "operation": {},
    "operationModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['submit', 'cancel'], ["update:operation"]),
  setup(__props: any, { emit: __emit }) {


const emit = __emit



const props = __props

// making the v-model required
const operation = _useModel(__props, 'operation')

//src\controllers\workspaces\tickets\_model\ticket.item.controller.ts
const context = useAppContext();



//const state:{operation:CategoryOperation} = reactive({operation: CategoryOperation.Plan})

const h =
{
  category: {




    plan_setup_aux(){
      operation.value = CategoryOperation.Plan
    },

    report_setup_aux(){
      operation.value = CategoryOperation.Report
    },

    submit(){
      emit('submit')
    },
    cancel(){
      emit('cancel')
    }


    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("span", {
        class: "clickable",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (h.category.plan_setup_aux && h.category.plan_setup_aux(...args)), ["stop"]))
      }, "Plan"),
      _createTextVNode(" | "),
      _createElementVNode("span", {
        class: "clickable",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (h.category.report_setup_aux && h.category.report_setup_aux(...args)), ["stop"]))
      }, "Report")
    ]),
    _createElementVNode("div", null, [
      (operation.value == _unref(CategoryOperation).Plan)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_1,
            _createVNode(AppointmentComponent, {
              workspace: _ctx.project_model.workspace,
              storage: _ctx.project_model.workspace.storage,
              category: props.category,
              date: new Date(),
              onSubmit: _cache[2] || (_cache[2] = ($event: any) => (h.category.submit())),
              onCancel: _cache[3] || (_cache[3] = ($event: any) => (h.category.cancel()))
            }, null, 8, ["workspace", "storage", "category", "date"])
          ], 64))
        : _createCommentVNode("", true),
      (operation.value == _unref(CategoryOperation).Report)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_2,
            _createVNode(TimingComponent, {
              category: _ctx.category,
              efforts: _unref(context).userEfforts() ?? undefined,
              prompt: _ctx.prompt,
              participants: _ctx.category == _unref(Category).M
            }, null, 8, ["category", "efforts", "prompt", "participants"])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})